export default __webpack_public_path__ + "static/media/crypto-04.65aae950.png";